import { NDivider } from 'nayan';

const Projects = () => {
  return (
    <div className="p-3">
      <div className="text-lg font-bold mb-1">Webex Contact Center Analyzer by Cisco</div>
      <div className="text-muted text-sm mb-3">Full Stack Developer, Apr 2021 – Present</div>
      <div className="mb-3 leading-relaxed">
        Webex Contact Center Analyzer mines real-time and historical data from multiple data sources and systems to generate specific business views
        of the data. The Analyzer visually displays trends to help you discern patterns and gain insights for continuous improvement.
      </div>
      <div className="font-bold mb-3">Responsibilities</div>
      <ul className="list-disc pl-5 leading-relaxed mb-3">
        <li>Participating in PLT meetings to gather requirements from Different stakeholders.</li>
        <li>Designing new components and Creating POC’s for the Upcoming feature developments.</li>
        <li>Integrating and managing Company SSO to avoid custom user authentication and authorizations.</li>
        <li>Extensively worked in defining micro front end architecture with mono repo for the application scalability and code sharing.</li>
        <li>
          Extensively worked in developing user interfaces with Frontend technologies like HTML5, CSS3, Javascript, Typescript, Angular, ReactJS,
          Redux, Tailwind css, and Micro front end Architecture.
        </li>
        <li>
          Extensively worked in developing backend micro services with different technologies like Node JS, Nest JS, GraphQL, JAVA Spring boot and
          Micro service architecture.
        </li>
        <li>Extensively worked on Unit testing, Integration testing and Functional testing to achieve complete test driven development.</li>
        <li>Implemented complete application automation with Cypress to avoid 90% manual testing for every deployment.</li>
        <li>
          Implemented complete automation for the Continuous integration and Continuous deployments using Devops tools like Jenkins, Docker and
          Kubernetes.
        </li>
        <li>
          Integrated tools for monitoring production application performance and error collection with App Dynamics, Grafena, Prometheus, Kibana and
          Mixpanel.
        </li>
        <li>Participating in code reviews and validating code for better performance, Code quality and Code smells.</li>
        <li>Spent a good amount of time on fixing cyber security issues found through PEN testing.</li>
        <li>Guiding Junior engineers on product development.</li>
      </ul>
      <div className="mb-5 leading-relaxed">
        <strong>Environment:</strong> HTML5, CSS3, Bootstrap, JavaScript, Typescript, React JS, Redux, Node JS, Nest JS, Cypress, Jest, MySQL,
        MongoDB, Apache Kafka, Zookeeper, Docker, Jenkins, Kubernetes, AWS, AppDynamics, Grafena, Prometheus, Kibana, Mixpanel, Micro Front End, Mono
        Repo.
      </div>
      <NDivider className="mb-5" />

      <div className="text-lg font-bold mb-1">Wealth & Investment Portfolio by Wellsfargo</div>
      <div className="text-muted text-sm mb-3">Full Stack Developer, Oct 2020 – Apr 2021</div>
      <div className="mb-3 leading-relaxed">
        Wealth & Investment Portfolio is an web application designed and used by a wealth planning team, Wealth planning team uses this tool in
        decision making, situational analysis, tracking assets and providing consultations to the clients. This tool will take data from a wide
        variety of sources and build forecasts for future investments.
      </div>
      <div className="font-bold mb-3">Responsibilities</div>
      <ul className="list-disc pl-5 leading-relaxed mb-3">
        <li>Gathering requirements from Different stakeholders and Business analysts.</li>
        <li>
          Extensively worked in developing user interfaces with Frontend technologies like HTML5, CSS3, Javascript, Typescript, ReactJS, Redux,
          Bootstrap.
        </li>
        <li>Extensively worked in developing backend micro services with different technologies like Node JS, Nest JS and Feathers JS, SocketIO.</li>
        <li>Extensively worked on Unit testing, Integration testing and Functional testing to achieve complete test driven development.</li>
        <li>Participating in code reviews and validating code for better performance, Code quality and Code smells.</li>
      </ul>
      <div className="mb-5 leading-relaxed">
        <strong>Environment:</strong> HTML5, CSS3, Bootstrap, JavaScript, Typescript, React JS, Redux, React Native, Angular JS, Angular, Ionic
        Framework, Node JS, Nest JS, Feathers JS, Cypress, Jest, MongoDB, Rabbit MQ, Docker, Jenkins, Swarm, Azure,, Grafena, Portainer, Graylog,
        Micro services, Mobile applications.
      </div>
      <NDivider className="mb-5" />

      <div className="text-lg font-bold mb-1">EcoStruxure Facility Expert by Schneider Electric</div>
      <div className="text-muted text-sm mb-3">Full Stack Developer & Mobile app developer, Sep 2017 – Oct 2020</div>
      <div className="mb-3 leading-relaxed">
        EcoStruxure Facility Expert is an Hybrid mobile and web application designed for maintenance teams to operate equipment and buildings – single
        or multi sites - more efficiently by making routine maintenance easier and troubleshooting faster. using this app we can also control and
        operate schneider manufactured devices remotely.
      </div>
      <div className="font-bold mb-3">Responsibilities</div>
      <ul className="list-disc pl-5 leading-relaxed mb-3">
        <li>Gathering requirements from Different stakeholders and Business analysts.</li>
        <li>Designing new components and Creating POC’s for the Upcoming feature developments.</li>
        <li>
          Extensively worked in developing user interfaces with Frontend technologies like HTML5, CSS3, Javascript, Typescript, Angular, ReactJS,
          Redux, Bootstrap, Ionic Framework and React Native.
        </li>
        <li>Extensively worked in developing backend micro services with different technologies like Node JS, Nest JS and Feathers JS.</li>
        <li>Extensively worked on Mobile application development and publishing on google play store and Apple app store.</li>
        <li>Automated Mobile App publishing and Over the Air (OTA) updates, with this the app review process has been drastically simplified.</li>
        <li>Extensively worked in writing minimal code in building re-usable components for both web and mobile.</li>
        <li>Extensively worked on Unit testing, Integration testing and Functional testing to achieve complete test driven development.</li>
        <li>
          Implemented complete automation for the Continuous integration and Continuous deployments using Devops tools like Jenkins, Docker, Swarm and
          Portainer.
        </li>
        <li>Integrated tools for monitoring production application performance and error collection with Grafena, Portainer, Graylog.</li>
        <li>Participating in code reviews and validating code for better performance, Code quality and Code smells.</li>
      </ul>
      <div className="mb-5 leading-relaxed">
        <strong>Environment:</strong> HTML5, CSS3, Bootstrap, JavaScript, Typescript, React JS, Redux, React Native, Angular JS, Angular, Ionic
        Framework, Node JS, Nest JS, Feathers JS, Cypress, Jest, MongoDB, Rabbit MQ, Docker, Jenkins, Swarm, Azure,, Grafena, Portainer, Graylog,
        Micro services, Mobile applications.
      </div>
      <NDivider className="mb-5" />

      <div className="text-lg font-bold mb-1">PayZapp by HDFC Bank</div>
      <div className="text-muted text-sm mb-3">Full Stack Developer & Mobile app developer, Jun 2014 – Sep 2017</div>
      <div className="mb-3 leading-relaxed">
        HDFC Bank PayZapp is a complete payment solution, giving you the power to pay in just One Click. With PayZapp, you can shop on your mobile at
        partner apps, buy movie tickets, groceries, compare and book flight tickets and hotels, shop online and get great discounts at SmartBuy, send
        money to anyone in your contact list or to your bank account, pay bills and recharge your mobile, DTH and data card and many more.
      </div>
      <div className="font-bold mb-3">Responsibilities</div>
      <ul className="list-disc pl-5 leading-relaxed mb-3">
        <li>Gathering requirements from Different stakeholders and Business analysts.</li>
        <li>Designing new components and Creating POC’s for the Upcoming feature developments.</li>
        <li>
          Extensively worked in developing user facing applications with HTML5, CSS3, Javascript, JQuery, Angular JS, Bootstrap, PHP, MySQL, Java.
        </li>
        <li>Extensively worked on Mobile application development and publishing on google play store and Apple app store.</li>
        <li>Automated Mobile App publishing and Over the Air (OTA) updates, with this the app review process has been drastically simplified.</li>
        <li>Extensively worked in writing minimal code in building re-usable components for both web and mobile.</li>
        <li>Participating in code reviews and validating code for better performance, Code quality and Code smells.</li>
      </ul>
      <div className="mb-5 leading-relaxed">
        <strong>Environment:</strong> HTML5, CSS3, Bootstrap, Javascript, JQuery, Angular JS, Bootstrap, PHP, MySQL, Java..
      </div>
    </div>
  );
};

export default Projects;
